import { cn } from '#/lib/utils';
import { HelpCircle } from 'lucide-react';
import { ReactNode } from 'react';
import { Tooltip, TooltipProps } from './tooltip';

interface Props extends Omit<TooltipProps, 'children'> {
  content?: ReactNode;
}

export function HelpTooltip({ className, ...props }: Props) {
  return (
    <Tooltip
      className={cn('w-4 h-4 inline-flex align-middle', className)}
      {...props}
    >
      <HelpCircle className="w-full h-full" />
    </Tooltip>
  );
}
